/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCreateOptions = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17.274 12.297a1.014 1.014 0 0 1 1.433 0l2.981 2.98c.396.396.396 1.038.001 1.433l-5.274 5.294H12V17.59zM20 2v8h-2V4H4v16h6v2H2V2zm-2.009 12.409L14 18.416v1.587h1.584l3.993-4.008zM8 11v2H6v-2zm6 0v2h-4v-2zM8 7v2H6V7zm8 0v2h-6V7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCreateOptions as CreateOptions };
